<div class="overview-admin-actions-container">
  <ul>
    @for (action of actions; track action.label; let i = $index) {
      <li>
        <label [for]="action.onClick ? 'actionLink_' + i : 'nonActionText_' + i">
          {{action.label}}
        </label>
        @if (action.onClick) {
          <a id="actionLink_{{i}}" class="mx-2"
            class="red-text-link mx-2"
            [attr.role]="action.role"
            (click)="clickAction(action)"
            tabindex="0">
            {{action.actionText}}
          </a>
        } @else {
          <span id="nonActionText_{{i}}"
            class="fw-bold mx-2">
            {{action.actionText}}
          </span>
        }
      </li>
    }
  </ul>
</div>
